import { useTranslation } from 'react-i18next';

const useValidate = () => {
  const { t: translate } = useTranslation();

  const required = (value, msg) => (!value ? msg || 'Required' : undefined);

  const numberInRange = (value, min, max, msg) => {
    if (!value) {
      return msg || 'Required';
    }
    const num = +value;
    if (!num) {
      return 'Invalid value';
    }
    return num >= min && num <= max ? undefined : 'Invalid value';
  };

  const numberLength = (value, lng, msg) => {
    if (!value) {
      return msg || 'Required';
    }
    if (value.length !== lng || !+value) {
      return msg || 'Invalid value';
    }
    return undefined;
  };

  const numberLengthRange = (value, lngMin, lngMax, msg) => {
    if (!value) {
      return msg || 'Required';
    }

    if (value.length < lngMin || value.length > lngMax || !+value) {
      return msg || 'Invalid value';
    }
    return undefined;
  };

  const ifPredicate = (predicate, msg) =>
    predicate ? translate(msg) : undefined;

  const validateCreditCardNumber = (value, msg) => {
    if (!value) {
      return msg || 'Required';
    }

    if (numberLengthRange(value?.replace(/\s+/g, ''), 14, 16)) {
      return msg || 'Invalid card number';
    }

    return undefined;
  };

  return {
    required,
    numberInRange,
    numberLength,
    ifPredicate,
    numberLengthRange,
    validateCreditCardNumber,
  };
};

export default useValidate;
